import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', () => {
    // 1. Select all block instances on the page
    const blocks = document.querySelectorAll('.team-carousel-block');

    blocks.forEach((block) => {
        // 2. Parse Configuration
        if (!block.dataset.swiperConfig) return;
        const baseConfig = JSON.parse(block.dataset.swiperConfig);
        
        // 3. Target the specific carousel container within this block
        const carouselContainer = block.querySelector('.team-content');
        
        // Safety check: if no posts were found in PHP, this container might not exist
        if (!carouselContainer) return;

        // 4. Select Controls (Scoped to this block)
        // We use querySelectorAll to grab BOTH Desktop and Mobile arrows
        const prevButtons = block.querySelectorAll('.swiper-button-prev');
        const nextButtons = block.querySelectorAll('.swiper-button-next');
        const paginationEl = block.querySelector('.swiper-pagination');

        // Ensure required classes exist
        carouselContainer.classList.add('swiper');

        // 5. Prepare Swiper Config
        const instanceConfig = { 
            modules: [Navigation, Pagination, Autoplay, Keyboard],
            ...baseConfig,

            // Essential for dynamic layouts or hidden elements
            observer: true,
            observeParents: true,

            // Enable arrow key navigation
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            
            // Accessibility
            a11y: {
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
            },
        };

        // 6. Bind Navigation
        // Swiper allows passing an Array of HTML elements to control one slider
        if (baseConfig.navigation && prevButtons.length > 0) {
            instanceConfig.navigation = {
                nextEl: Array.from(nextButtons), // Convert NodeList to Array
                prevEl: Array.from(prevButtons),
            };
        } else {
            instanceConfig.navigation = false;
        }

        // 7. Bind Pagination
        if (baseConfig.pagination && paginationEl) {
            instanceConfig.pagination = {
                el: paginationEl,
                clickable: true,
                type: 'bullets',
            };
        } else {
            instanceConfig.pagination = false;
        }

        // 8. Initialize Swiper
        new Swiper(carouselContainer, instanceConfig);
    });
});